<template>
    <div>Loading...</div>
</template>

<script>
import oauth2 from '../../config/oauth2'
import qs from 'qs'

export default {
  name: 'OAuthCallback',
  created () {
    const that = this
    const params = this.$helper.getQueryParams()
    let data = {
      code: params.code,
      redirectUri: oauth2.redirectUri,
      state: params.state
    }

    this.$http.post('/api/1/oauth/dggd/authorize', qs.stringify(data)).then(function (data) {
      if (data.code !== 200) {
        return
      }
      console.log(data)
      that.$store.dispatch('SetToken', data.user.token).then(function () {
        var path = params.state
        // eslint-disable-next-line no-undef
        window.location = process.env.VUE_APP_WEB_SERVER + '/#' + path
        // window.location = process.env.VUE_APP_WEB_SERVER
      })
    })
  }
}
</script>

<style scoped>

</style>
